module.exports = __webpack_public_path__ + "img/screen-tik.39c4df8d.png";